import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import request from '../../utils/request';
import { sortedObjects } from '../../utils/utils';
import Label from './common/label';

const Channel = ({ labels, errors, touched, values, setFieldValue }) => {
  const [channelsList, setChannelsList] = useState([]);

  useEffect(() => {
    request.get('/channels').then(({ data: { channels } }) => {
      const updatedChannelList = sortedObjects(channels, 'description').map(
        ({ name, description }) => {
          return { id: name, label: description };
        }
      );
      setChannelsList(updatedChannelList);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_CHANNEL} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.channel && touched.channel ? 'error' : ''
        }`}
      >
        <Typeahead
          id="channel"
          labelKey="label"
          options={channelsList}
          onChange={e => {
            setFieldValue('channel', e);
          }}
          placeholder={labels.CHANNELS_SELECT}
          selected={values.channel || []}
          clearButton
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.channel}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

Channel.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default Channel;
